export default __webpack_public_path__ + "static/media/mffm_farbe1.8277fe7e.svg";